import { Warning } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from "@mui/material";

import { CoachingArtifact } from "../hooks/useCoachingArtifacts";

interface DuplicateConfigurationDialogProps {
  open: boolean;
  artifact: CoachingArtifact | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const DuplicateConfigurationDialog = ({
  open,
  artifact,
  onConfirm,
  onCancel
}: DuplicateConfigurationDialogProps) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Warning color="warning" />
      Similar Configuration Detected
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        A coaching artifact with the same configuration already exists:
      </DialogContentText>
      {artifact && (
        <Box sx={{ mt: 2, p: 2, bgcolor: "grey.50", borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Generated:</strong> {new Date(artifact.created).toLocaleString()}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            <strong>Time Range:</strong> {artifact.source_data_filter?.timeRange}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            <strong>Attributes:</strong> {artifact.lens_config?.selectedAttributes?.join(", ")}
          </Typography>
        </Box>
      )}
      <DialogContentText sx={{ mt: 2 }}>
        Would you like to regenerate with the same configuration, or modify your settings first?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Modify Configuration</Button>
      <Button onClick={onConfirm} variant="contained" color="primary">
        Regenerate Anyway
      </Button>
    </DialogActions>
  </Dialog>
);

export default DuplicateConfigurationDialog;
